export default "__VITE_ASSET__1v8ggK4j__"